import axios from "axios";
import React, { useState } from "react";
import { useHistory } from "react-router";
import { useParams } from "react-router-dom";
import { ModalError, ModalSuccess } from "components";
import { hardBaseUrl } from "../../../services/urlConstant";
import FormInvoice from "./Components/FormInvoice";
import { downloadFileFromRes, getErrors } from "utils";
import Swal from "sweetalert2";

function EditInvoice() {
  const history = useHistory();
  const { id } = useParams();
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const [loadingPage, setLoadingPage] = useState(false);

  // Helper untuk menangani download validasi saat terjadi error
  const handleValidationDownload = async (payload, headers) => {
    const isUsage = payload.type === "usage";

    // 1. Siapkan Parameter (Gunakan .map().join() untuk format URL yang aman)
    const ids = isUsage
      ? payload.songs.map(s => s.song_id).join(",")
      : payload.header_ids;

    const queryParam = isUsage ? "song_ids" : "header_ids";
    const url = `${hardBaseUrl}/publisher/transaction/v2/sales-invoice/export-validation?${queryParam}=${ids}`;

    try {
      const res = await axios.get(url, { headers, responseType: "blob" });
      downloadFileFromRes(res);
    } catch (err) {
      console.error("Gagal mendownload file validasi:", err);
    }
  };

  // Fungsi Utama
  const handlSubmitData = async payload => {
    setLoadingPage(true);

    try {
      // 1. Kirim Update Data
      await axios.put(
        `${hardBaseUrl}/publisher/transaction/v2/sales-invoice/${id}`,
        payload,
        { headers }
      );

      // 2. Berhasil
      await ModalSuccess("Invoice has been updated");
      history.goBack();
    } catch (error) {
      // 3. Tangani Error
      const errorMessage =
        error?.response?.data?.errors?.[0]?.message ||
        error.response?.data?.errors.message ||
        "Terjadi kesalahan";

      const { isConfirmed } = await Swal.fire({
        customClass: { container: "swal-container" },
        title: "Error",
        text: errorMessage,
        icon: "error",
        confirmButtonText: "OK",
        showCancelButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
      });

      // 4. Jika user klik OK, jalankan proses download validasi
      if (isConfirmed) {
        await handleValidationDownload(payload, headers);
      }
    } finally {
      setLoadingPage(false);
    }
  };

  return (
    <FormInvoice
      pageTitle="Edit Invoice"
      pageSubTitle="Edit your transaction here"
      loadingPage={loadingPage}
      onSubmitPayload={handlSubmitData}
      setLoadingPage={setLoadingPage}
    />
  );
}

export default EditInvoice;
